import { Injectable } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {
  private toast_subject = new Subject<any>();
  toast_state = this.toast_subject.asObservable();

  constructor(
    private confirmationService: ConfirmationService
  ) { }

  getDialogue(): Observable<any> {
    return this.toast_subject.asObservable();
  }

  showConfirmation(
    text: string,
    title: string = 'Confirmation',
    confirmButtonText: string = 'Yes',
    cancelButtonText: string = 'No',
  ): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.confirmationService.confirm({
        header: title,
        message: text,
        acceptLabel: confirmButtonText,
        rejectLabel: cancelButtonText,
        accept: () => {
          resolve(true);
        },
        reject: () => {
          resolve(false);
        },
        acceptVisible: true,
        rejectVisible: true,
        //rejectable: true,
        icon: 'pi pi-exclamation-triangle',
        //acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        acceptButtonStyleClass: 'p-button-success',
        rejectButtonStyleClass: 'p-button-danger',
      });
    });
  }

  showSuccess(message: string): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.confirmationService.confirm({
        message: message,
        header: 'Success',
        accept: () => {
          resolve(true);
        },
        rejectVisible:false,
        acceptLabel: 'Ok',
        icon: 'pi pi-check-circle',
        acceptButtonStyleClass: 'p-button-primary'
      });
    })
  }

  showWarning(message: string): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.confirmationService.confirm({
        message: message,
        header: 'Warning',
        accept: () => {
          resolve(true);
        },
        rejectVisible:false,
        acceptLabel: 'Ok',
        icon: 'pi pi-exclamation-circle',
        acceptButtonStyleClass: 'p-button-primary'
      });
    })
  }
}
